import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  inject,
  signal,
  computed,
  model,
  output,
  effect,
  untracked,
  ViewEncapsulation,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { ToastService } from 'src/app/services/toast.service';
import { first } from 'rxjs/operators';
import { MrTranslatePipe } from 'src/app/pipes/mr-translate.pipe';
import { APIService } from 'src/app/services/APIService/api.service';
import { AuthService } from 'src/app/services/Auth/auth.service';
import { CommonModule } from '@angular/common';
import { ClarityModule } from '@clr/angular';
import JSZip from 'jszip';
import MDBReader from 'mdb-reader';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { firstValueFrom, from } from 'rxjs';
import { concatMap, tap, finalize } from 'rxjs/operators';
import { ConfirmService } from 'src/app/services/confirm.service';
import { FormGroupOfType } from 'src/app/types/shared';
import { KTOLR } from 'src/app/services/_offline/zaehlerDB';
import { DBStatus } from 'src/app/types/api';
import { Table } from 'src/app/models/ui/table';
import { ColorInput } from '../../_shared/color-input/color-input';
import { DropZoneDirective } from '../../../../directives/drop-zone.directive';
import { SOTYP } from 'src/app/models/api/SOTYP';

//#region Interfaces
interface messreg {
  filename: string;
  dat: string;
  error: boolean;
  errortext: string;
  mess: {};
}

interface SwitchItem {
  id: string;
  name: string;
  location: string;
  gemoetry: string;
  pruefer: string;
  messpunkte: Messpunkte[];
}
interface Messpunkte {
  id: Number;
  bezeichner: string;
  messwert: number;
  srwert: number;
  soll: number;
  gw1m: number;
  gw2m: number;
  gw3m: number;
  gw4m: number;
  gw5m: number;
  gw1p: number;
  gw2p: number;
  gw3p: number;
  gw4p: number;
  gw5p: number;
  mpinfo: string;
  distance: Number;
  messdatum: Date;
}
//#endregion

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-weichen-mess-import',
  templateUrl: './weichen-messdaten-import.html',
  styleUrls: ['./weichen-messdaten-import.scss'],
  imports: [
    CommonModule,
    ClarityModule,
    DropZoneDirective,
    MrTranslatePipe,
    FormsModule,
    ReactiveFormsModule,
    ColorInput,
  ],
  encapsulation: ViewEncapsulation.None,
})
export class MessRegModalComponent implements OnInit {
  private readonly apiService = inject(APIService);
  private readonly toastr = inject(ToastService);
  private readonly authService = inject(AuthService);
  private readonly mrTranslate = inject(MrTranslatePipe);
  private readonly confirmService = inject(ConfirmService);

  readonly isOpen = model.required<boolean>();
  readonly reload = output<void>();

  protected readonly accept = signal('.v40');

  protected readonly trial = this.authService.getToken().trial;

  protected readonly isFullScreen = signal(false);

  protected readonly isGrossBuchstaben = signal(false);
  protected readonly isIIS = signal(false);
  protected readonly ohneUeberhoehung = signal(false);

  protected readonly switches = signal<SwitchItem[]>([]);
  protected readonly selectedSwitch = signal<SwitchItem | null>(null);
  protected readonly selectedMpSet = computed(() => this.selectedSwitch()?.messpunkte ?? []);

  protected readonly allSwitchesHavePruefer = signal(false);

  token: any;
  toleranzen: Table<KTOLR>;
  selectedMessgeraet: String = 'Messprofil V3.0';
  protected readonly isNeuTol = signal(false);
  _toltexttyp: number = 0;

  protected readonly optionsD = signal(false);
  protected readonly optionsLK = signal(false);
  protected readonly isCustomText = signal(true);
  protected readonly customText = signal('');
  filelistcount: number = 0;
  uploadFile: File | null;
  isDarkThemeAktiv = false;

  fileContent: any;
  isLoading: boolean = false;

  downloadingFile = false;
  hassendet: boolean = false;
  sotyp: SOTYP[];
  otypid: number = 1;
  symbol: number;

  getAutoIhItems: any = [];
  daten: Array<messreg> = [];

  protected readonly messtol = new FormGroupOfType<Omit<KTOLR, 'ID' | keyof DBStatus>>({
    USE_0: new FormControl({ value: true, disabled: true }, { nonNullable: true }),
    USE_100: new FormControl(true, { nonNullable: true }),
    USE_L: new FormControl(true, { nonNullable: true }),
    USE_G: new FormControl(true, { nonNullable: true }),
    TEXT_0_m: new FormControl('SR0 +', { nonNullable: true }),
    TEXT_0_p: new FormControl('SR0 -', { nonNullable: true }),
    TEXT_100_m: new FormControl('SR100 +', { nonNullable: true }),
    TEXT_100_p: new FormControl('SR100 -', { nonNullable: true }),
    TEXT_L_m: new FormControl('SRLim +', { nonNullable: true }),
    TEXT_L_p: new FormControl('SRLim -', { nonNullable: true }),
    TEXT_G_m: new FormControl('SRG +', { nonNullable: true }),
    TEXT_G_p: new FormControl('SRG -', { nonNullable: true }),
    TEXT_0_A: new FormControl('SR0', { nonNullable: true }),
    TEXT_100_A: new FormControl('SR100', { nonNullable: true }),
    TEXT_L_A: new FormControl('SRLim', { nonNullable: true }),
    TEXT_G_A: new FormControl('SRG', { nonNullable: true }),
    TEXT_0_S: new FormControl('SR0', { nonNullable: true }),
    TEXT_100_S: new FormControl('SR100', { nonNullable: true }),
    TEXT_L_S: new FormControl('SRLim', { nonNullable: true }),
    TEXT_G_S: new FormControl('SRG', { nonNullable: true }),
    TEXT_Ausfall_0: new FormControl('Toleranzverletzung', { nonNullable: true }),
    TEXT_Ausfall_I: new FormControl('Toleranzverletzung', { nonNullable: true }),
    COLOR_0: new FormControl('#87CEFA', { nonNullable: true }),
    COLOR_100: new FormControl('#90EE90', { nonNullable: true }),
    COLOR_L: new FormControl('#FFFF00', { nonNullable: true }),
    COLOR_G: new FormControl('#FF0000', { nonNullable: true }),
  });

  constructor() {
    effect(() => {
      if (!this.isOpen()) return;

      untracked(async () => {
        const { toleranzen, ini, sotyp } = await firstValueFrom(this.apiService.getMessTol());
        this.toleranzen = toleranzen;
        this.messtol.reset(this.toleranzen.rows[0]);
        this.isCustomText.set(!!ini.optMessTol);
        this.customText.set(ini.optMessTolBez);
        this.sotyp = sotyp.rows;
        this.symbol = this.sotyp[0].symbol;
      });
    });
  }

  ngOnInit() {
    let mg = localStorage.getItem('messreg');
    if (mg) {
      this.selectedMessgeraet = mg;
    }
  }

  protected checkPruefer(): void {
    this.allSwitchesHavePruefer.set(this.switches().every(sw => sw.pruefer?.trim().length > 0));
    this.filelistcount = 1;
  }

  async deleteSwitch(id: string) {
    const sw = this.switches().find(sw => sw.id === id);

    let ok = true;

    if (sw && this.getGemessen(sw) > 0) {
      ok = await this.confirmService.danger(
        this.mrTranslate.transform('Sind Sie sicher, dass Sie diesen Eintrag löschen wollen?')
      );
    }

    if (ok) {
      this.switches.set(this.switches().filter(sw => sw.id !== id));
      this.checkPruefer();
    }

    if (this.switches().length == 0) {
      this.isFullScreen.set(false);
      this.filelistcount = 0;
    }
  }

  selectSwitch(sw: SwitchItem) {
    this.selectedSwitch.set(sw);
  }

  getGemessen(sw) {
    return sw.messpunkte.filter(mp => mp.srwert >= 0).length;
  }

  /*
  Felder toleranzen
  ID, USE_100, USE_L, USE_G, TEXT_0_m, TEXT_0_p, TEXT_100_m, TEXT_100_p, TEXT_L_m, TEXT_L_p, TEXT_G_m, TEXT_G_p, TEXT_0_A, TEXT_100_A, TEXT_L_A, TEXT_G_A, TEXT_0_S, TEXT_100_S, TEXT_L_S, TEXT_Ausfall_0, TEXT_Ausfall_I, TEXT_G_S, COLOR_0, COLOR_100, COLOR_L, COLOR_G
  */

  getDate(strDate: string) {
    if (strDate == null || strDate == '') return null;
    strDate = strDate.replaceAll('"', '');

    const [datePart, timePart] = strDate.split(' ');
    const [day, month, year] = datePart.split('.').map(Number);
    const [hours, minutes, seconds] = timePart.split(':').map(Number);
    return new Date(year, month - 1, day, hours, minutes, seconds);
  }

  parseNumber(value: string | null | undefined, defaultValue = 0): number {
    if (!value?.trim()) {
      return defaultValue;
    }

    return Number(value.replace(',', '.'));
  }

  onDrop(files: File[]) {
    if (this.selectedMessgeraet == 'Messprofil XML' && files?.length > 0) {
      const file = files?.[0];
      if (!file) return;

      const reader = new FileReader();
      reader.onload = () => {
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(reader.result as string, 'text/xml');

        const switchList: SwitchItem[] = Array.from(xmlDoc.getElementsByTagName('SWITCH')).map(sw => ({
          id: sw.getAttribute('SWITCH_KEY') ?? '',
          name: sw.getAttribute('SWITCH_NAME') ?? '',
          location: sw.getAttribute('SWITCH_LOCATION') ?? '',
          gemoetry: sw.getAttribute('SWITCH_GEOMETRY') ?? '',
          gemessen: 0,
          pruefer: '',

          messpunkte: Array.from(sw.getElementsByTagName('MP')).map(Messpunkte => ({
            id: Number(Messpunkte.getElementsByTagName('IDX')[0]?.textContent),
            bezeichner: Messpunkte.getElementsByTagName('MP_NAME')[0]?.textContent ?? '',
            messwert: this.parseNumber(Messpunkte.getElementsByTagName('MEAS_VAL')[0]?.textContent),
            srwert: Number(Messpunkte.getElementsByTagName('MEAS_ERROR')[0]?.textContent || -1),
            soll: Number(Messpunkte.getElementsByTagName('DEF_VAL')[0]?.textContent),
            gw1m: Number(Messpunkte.getElementsByTagName('GW1M')[0]?.textContent),
            gw2m: Number(Messpunkte.getElementsByTagName('GW2M')[0]?.textContent),
            gw3m: Number(Messpunkte.getElementsByTagName('GW3M')[0]?.textContent),
            gw4m: Number(Messpunkte.getElementsByTagName('GW4M')[0]?.textContent),
            gw5m: Number(Messpunkte.getElementsByTagName('GW5M')[0]?.textContent),
            gw1p: Number(Messpunkte.getElementsByTagName('GW1P')[0]?.textContent),
            gw2p: Number(Messpunkte.getElementsByTagName('GW2P')[0]?.textContent),
            gw3p: Number(Messpunkte.getElementsByTagName('GW3P')[0]?.textContent),
            gw4p: Number(Messpunkte.getElementsByTagName('GW4P')[0]?.textContent),
            gw5p: Number(Messpunkte.getElementsByTagName('GW5P')[0]?.textContent),
            mpinfo: Messpunkte.getElementsByTagName('INFOTEXT')[0]?.textContent,
            distance: Number(Messpunkte.getElementsByTagName('GW5P')[0]?.textContent),
            messdatum: this.getDate(Messpunkte.getElementsByTagName('MEAS_DATE')[0]?.textContent ?? ''),
          })),
        }));

        this.switches.set(switchList);
        this.isFullScreen.set(true);
      };

      reader.readAsText(file);
      return;
    }

    for (let i = 0; i < this.daten.length; i++) {
      for (let index = 0; index < files.length; index++) {
        if (this.daten[i].filename == files[index].name) {
          this.removeFileFromArray(this.daten[i]);
        }
      }
    }

    for (let index = 0; index < files.length; index++) {
      if (files[index].name.toLowerCase().endsWith(this.accept())) {
        const file = files[index];

        let mr: messreg = {
          filename: file.name,
          error: false,
          errortext: '',
          dat: '',
          mess: '',
        };

        this.daten.push(mr);
        this.filelistcount = this.daten.length;

        if (files[index].name.toLowerCase().endsWith('.v40')) {
          let fileReader: FileReader = new FileReader();
          let $this = this;
          fileReader.onloadend = function (x) {
            var jsZip = typeof (<any>JSZip).default === 'function' ? new (<any>JSZip).default() : new JSZip();
            jsZip.loadAsync(file).then(zip => {
              Object.keys(zip.files).forEach(filename => {
                if (filename.toUpperCase() == 'DATA.MDB') {
                  zip.files[filename].async('blob').then(fileData => {
                    try {
                      var fileReader = new FileReader();
                      fileReader.onload = function (event) {
                        const result = event.target.result;
                        let _buffer: Buffer;
                        if (typeof result === 'string') {
                          // If it's a string, specify an encoding (adjust if needed)
                          _buffer = Buffer.from(result, 'utf8');
                        } else if (result instanceof ArrayBuffer) {
                          // Convert the ArrayBuffer to a Uint8Array
                          _buffer = Buffer.from(new Uint8Array(result));
                        } else {
                          throw new Error('Unexpected result type');
                        }
                        const data = {};
                        const reader = new MDBReader(_buffer);
                        for (const tableName of reader.getTableNames()) {
                          if (
                            tableName.toUpperCase() == 'MESSWERTE' ||
                            tableName.toUpperCase() == 'MW_ABGELEITET' ||
                            tableName.toUpperCase() == 'INSPEKTIONEN'
                          ) {
                            data[tableName] = reader.getTable(tableName).getData();
                            data[tableName + '_c'] = reader.getTable(tableName).getColumns();
                          }
                        }
                        mr.mess = data;
                      };
                      fileReader.readAsArrayBuffer(fileData);
                    } catch (e) {
                      $this.fileContent = fileData;
                    }
                    $this.isLoading = false;
                  });
                }

                if (filename.toUpperCase() == 'INFO.DAT') {
                  zip.files[filename].async('string').then(fileData => {
                    try {
                      mr.dat = fileData;
                    } catch (e) {}
                  });
                }
              });
            });
          };
          fileReader.readAsText(file);
        } else {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => {
            const data = reader.result as string;
            mr.mess = data.split(',')[1];
          };
        }
      } else {
        this.toastr.error(
          this.mrTranslate.transform('Die Datei hat nicht das passende Format!') + ' ' + files[index].name
        );
      }
    }
  }

  onOptionsSelected(value: string) {
    if (value == 'Messprofil V3.0') this.accept.set('.v40');
    if (value == 'Messprofil XML') this.accept.set('.xml');
    this.selectedMessgeraet = value;
    localStorage.setItem('messreg', this.selectedMessgeraet.toString());
  }
  protected onFileInputChange(event: Event) {
    if ('files' in event.target) this.onDrop(Array.from((event.target as HTMLInputElement).files));
  }

  uploadMess(mess: messreg) {
    let m = btoa(JSON.stringify(mess));

    let toSend: any = {
      name: mess.filename,
      base64: m,
    };

    if (mess.filename.toLowerCase().endsWith('.xml')) {
      toSend = {
        name: mess.filename,
        base64: mess.mess,
      };
    }

    let options = {
      ToleranzNeu: this.isNeuTol(),
      lk: this.optionsLK(),
      dr: this.optionsD(),
      iis: this.isIIS(),
      gross: this.isGrossBuchstaben(),
      ouebh: this.ohneUeberhoehung(),
      optMessTol: this.isCustomText() ? 1 : 0,
      optMessTolBez: this.customText(),
      otypid: this.otypid,
    };

    toSend['options'] = options;
    return this.apiService.sendNewMessdaten(toSend).pipe(first());
  }

  /*
  uploadMess(mess: messreg) {

    let m = btoa(JSON.stringify(mess));

    let toSend = {};

    toSend['name'] = mess.filename;
    toSend['base64'] = m;


    let dr = false;
    if (this.optionsD())
      dr = true;

    let lk = false;
    if (this.optionsLK())
      lk = true;

    let tolneu = false;
    if (this.neuActive == true)
      tolneu = true;

    let ouebh = false;
    if (this.ouebh != undefined) {
      if (this.ouebh.nativeElement.checked == true)
        ouebh = true;
    }

    let vals = this.messini.value;
    let options = {
      ToleranzNeu: tolneu,
      lk: lk,
      dr: dr,
      iis: this.isIIS(),
      gross: this.isGrossBuchstaben(),
      ouebh: ouebh,
      optMessTol: parseFloat(vals.optMessTol),
      optMessTolBez: vals.optMessTolBez,
      otypid: this.otypid,
    }

    toSend['options'] = options;

    this.apiService
      .sendNewMessdaten(toSend)
      .pipe(first())
      .subscribe((res: any) => {
        if (res?.success) {
          this.removeFileFromArray(mess);
        }
        else {
          this.setError(mess, "Error: " + res.message)
          this.toastr.error(mess.filename, res.message);
        }
        this.checkspinner();
        this.hassendet = true;
      });
  }
*/
  doexit() {
    this.daten = [];
    this.filelistcount = 0;
    this.isOpen.set(false);
    if (this.hassendet) this.reload.emit();
  }

  async runUpload() {
    if (this.isCustomText() && !this.customText()) {
      this.toastr.error(this.mrTranslate.transform('Geben Sie eine Toleranzbezeichnung ein'));
      return;
    }
    this.downloadingFile = true;
    this.hassendet = false;

    if (this.selectedMessgeraet == 'Messprofil XML') {
      const switches = this.switches();

      let options = {
        ToleranzNeu: this.isNeuTol(),
        lk: this.optionsLK(),
        dr: this.optionsD(),
        iis: this.isIIS(),
        gross: this.isGrossBuchstaben(),
        ouebh: this.ohneUeberhoehung(),
        optMessTol: this.isCustomText() ? 1 : 0,
        optMessTolBez: this.customText(),
        otypid: this.otypid,
      };

      for (const sw of switches) {
        let toSend: any = {
          name: '',
          base64: '',
          typ: 'xml',
          options: options,
          messung: sw,
        };

        try {
          const result: UploadResult = await firstValueFrom(this.apiService.sendNewMessdaten(toSend));

          if (result.success) {
            this.toastr.success(result.message);
            this.switches.set(this.switches().filter(sw1 => sw1.id !== sw.id));

            if (this.switches().length == 0) {
              this.isFullScreen.set(false);
              this.filelistcount = 0;
            }
          } else {
            this.toastr.error(result.message);
          }
        } catch (err) {
          console.error('HTTP Error', err);
        }
      }

      this.checkspinner();
      this.hassendet = true;

      return;
    } else {
      from(this.daten)
        .pipe(
          // 🔥 Runs one upload AFTER the previous finishes
          concatMap(mess =>
            this.uploadMess(mess).pipe(
              tap((res: any) => {
                if (res?.success) {
                  this.removeFileFromArray(mess);
                  this.toastr.success(mess.filename, res.message);

                  if (res.ptyp == '') this.getAutoIhItems.push(res.opruefid);
                } else {
                  this.setError(mess, 'Error: ' + res.message);
                  this.toastr.error(mess.filename, res.message);
                }
              })
            )
          ),

          // 🔥 Runs once after ALL uploads finished
          finalize(() => {
            this.checkspinner();
            this.hassendet = true;
            console.log('All sequential uploads finished');
          })
        )
        .subscribe({
          error: err => {
            console.error('Upload error:', err);
          },
        });
    }
  }

  checkspinner() {
    let find = false;
    const result = this.daten.find(({ error }) => error === false);
    if (!result || this.daten.length == 0) this.downloadingFile = false;
  }

  private setError(mess: messreg, text: string) {
    const index = this.daten.indexOf(mess);
    if (index > -1) {
      this.daten[index].error = true;
      this.daten[index].errortext = text;
    }
  }

  protected removeFileFromArray(mess: messreg) {
    const index = this.daten.indexOf(mess);
    if (index > -1) {
      this.daten.splice(index, 1);
      this.filelistcount = this.daten.length;
    }
  }

  saveSettings() {
    this.apiService
      .sendMessTol({
        messtol: this.messtol.getRawValue(),
      })
      .pipe(first())
      .subscribe((res: any) => {
        if (res?.status) this.toastr.success(this.mrTranslate.transform('Daten gespeichert'));
      });
  }
}
export interface UploadResult {
  success: boolean;
  message: string;
  id: string;
  file: string;
  opruefid: string;
  ptyp: string;
}
